<div class="main_content">
  <app-breadcrumb></app-breadcrumb>

  <div class="page_main_sec">

    <div class="general_form_sec p_25">
      <span class="form-field-legend2">
        <span style="font-size: 11px;color:#DB0000">Warning Message:Please refrain from
          uploading any attachment/Free text fields
          that contains Sensitive or Personally Identifiable Information (PII) without written consent
          from the controller (Customer). Consent is mandatory</span>
      </span><br><br>
      <div class="col-lg-12 text-end">
        <div class="table_pagination_sec ng-star-inserted">
          <h4 class="process_table_title ng-star-inserted">User Add/Update</h4>
        </div>

        <div class="form-container">
          <div class="row form-control-sec">
            <div class="col-md-12">
              <div [formGroup]="frmuser">

                <div class="row">
                  <div class="col-lg-3">
                    <mat-form-field [style.width.%]="100">

                      <input matInput [formControlName]="'USER_NAME'" id="UserName" maxlength="30">
                      <mat-label for="UserName">User Name
                        <span class="field-mandatory">*</span>
                      </mat-label>
                    </mat-form-field>
                  </div>
                  <!-- <div class="col-lg-3">
                    <mat-form-field appearance="legacy" [style.width.%]="100">

                      <mat-select id="Authentication" [formControlName]="'AUTHENTICATION_TYPE'" [attr.role]="null">
                        <mat-option [value]="option.id" *ngFor="let option of lstAuthenticationType">
                          {{option.name}}
                        </mat-option>
                      </mat-select>
                      <mat-label for="Authentication">Authentication <span class="field-mandatory">*</span></mat-label>
                    </mat-form-field>
                  </div> -->
                  <div class="col-lg-3">
                    <mat-form-field [style.width.%]="100">

                      <input matInput [formControlName]="'DISPLAY_NAME'" id="DisplayName" maxlength="30">
                      <mat-label for="DisplayName">Display Name
                        <span class="field-mandatory">*</span>
                      </mat-label>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-3">
                    <mat-form-field [style.width.%]="100">

                      <input matInput [formControlName]="'PRIMARY_EMAIL'" id="Email" maxlength="50">
                      <mat-label for="Email">Email
                        <span class="field-mandatory">*</span>
                      </mat-label>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-3">
                    <mat-form-field appearance="legacy" [style.width.%]="100">

                      <mat-select [formControlName]="'STATUS'" id="status" [attr.role]="null">
                        <mat-option [value]="option.id" *ngFor="let option of lstQueryStatus">
                          {{option.name}}
                        </mat-option>
                      </mat-select>
                      <mat-label for="status">Status <span class="field-mandatory">*</span></mat-label>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="action_buttons">

                      <button type="button"
                        class="btn primary_btn w120 waves-effect waves-light searchbtn smallButton user_btn"
                        (click)="AddUser()">{{buttonAction}}</button>
                      <button type="button" class="btn secondary_btn w120 waves-effect waves-light resetButton"
                        (click)="reset()">Reset</button>
                    </div>

                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="general_form_sec p_25">
      <div class="col-lg-12 move-right">
        <span class="download-template-wrp" (click)="downloadExcelTemplate();">
          <span><em class="material-icons">file_download</em></span> Download Template
        </span>
        <mat-toolbar class="file-upload-toolbar" (click)="userExcelUploadFileControl.click()">
          <div class="form-group">
            <div class="input-group">
              <input type="text" class="form-control fileuploadinput" title="file upload"
                [value]="userExcelUploadFileName" readonly>
              <div class="input-group-btn">
                <span class="fileUpload btn blueupload">
                  <span class="upl" id="upload">
                    Upload User Data
                  </span>
                  <input [attr.type]="fileControlType" class="upload up" id="up" title="upload"
                    #userExcelUploadFileControl (change)="onUserExcelFileUpload($event)" hidden
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                </span>
              </div>
            </div>
          </div>
        </mat-toolbar>
        <input type="button" class="btn user_btn" value="View User Data" (click)="viewUserData()"
          *ngIf="userColumn_upload.length >0 && userExcelData.length >0">
        <input type="button" class="btn user_btn" value="Add user data" (click)="uploadUserData()"
          *ngIf="userColumn_upload.length >0 && userExcelData.length >0 && isValidUserExcelData">
      </div>
    </div>

    <!-- <div class="form-container">
      <div class="row form-control-sec">
        <div class="col-md-12">
          <app-basic-gridview *ngIf="advanceSearchGridData.length > 0" [lstData]="advanceSearchGridData"
            [columnsToHide]="columnToHide" [gridTitle]="'User List'" [showExcelDownloadOption]="true"
            [showSearchOption]="true" [showRecordsPerPageOption]="true" [showPagination]="true"
            (cellClickEvent)="User_Details_grid_CellClick($event)" [exportToExcelFileName]="'Open-Search-Result'">
          </app-basic-gridview>
        </div>
      </div>
    </div> -->

    <app-basic-gridview *ngIf="advanceSearchGridData.length > 0" [lstData]="advanceSearchGridData"
      [columnsToHide]="columnToHide" [gridTitle]="'User List'" [showExcelDownloadOption]="true"
      [showSearchOption]="true" [showRecordsPerPageOption]="true" [showPagination]="true"
      (cellClickEvent)="User_Details_grid_CellClick($event)" [exportToExcelFileName]="'Open-Search-Result'"
      [columnsToExcludeFromExport]="['action_icon_Edit', 'action_icon_Access', 'action_icon_Delete', 'user_id']">
    </app-basic-gridview>

  </div>
</div>

<ng-template #userDataModal let-modal>
  <div class="modal-content">
    <div class="modal-header model_center_header">
      <h5 class="modal-title">User Data</h5>
      <button type="button" class="close model_close_btn" (click)="modalReference.close()">
        <span aria-hidden="true" class="model_close_btn">×</span>
      </button>
    </div>
    <div class="modal-body custom_modal_body">
      <div class="model_content">

        <div class="grpah-grid-table-responsive" *ngIf="userColumn_upload.length>0">
          <table class="grpah-grid-table responsive-table">
            <thead>
              <tr>
                <!-- <th></th> -->
                <th style="color: rgb(139, 139, 139);" *ngFor="let col of userColumn_upload">
                  {{col.DISPLAY_NAME}}
                </th>
                <th style="color: rgb(139, 139, 139);" *ngFor="let col of userDetailColumn_upload">
                  {{col.DISPLAY_NAME}}
                </th>
                <!-- <th style="color: rgb(139, 139, 139);">
                  Message
                </th> -->
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of userExcelData ">
                <!-- <td class="highlight">
                  <div>
                    <img *ngIf="data['Message']==''" src="../../../assets/img/right.png" alt="">
                    <img *ngIf="data['Message']!=''" src="../../../assets/img/wrong.png" alt="">
                  </div>
                </td> -->
                <td *ngFor="let col of userColumn_upload">
                  <span>{{data[col.DISPLAY_NAME]}}</span>
                </td>
                <td *ngFor="let col of userDetailColumn_upload">
                  <span>{{data[col.DISPLAY_NAME]}}</span>
                </td>
                <!-- <td>
                  <span> {{data["Message"]}}</span>
                </td> -->
                <td class="highlight right-align-high-light">
                  <div></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>


      </div>
    </div>
  </div>
</ng-template>